<template>
   <ThreeColumn :breadcrumbPaths="paths">

    <template v-slot:hero>
      <div class="navlink sponsor-header mb-3" >
        <v-row no-gutters>
          <!--SPACER LEFT PANEL--><v-col cols="12" md="2" lg="2"  class="hidden-sm-and-down"></v-col> 

          <v-col cols="12" md="8" lg="7" class="pt-5 pb-4 pl-lg-12 pl-xl-16" :class="$vuetify.breakpoint.xs?'px-4':'px-6'" >
            <h2 :class="lang=='en'? 'text-h2 display-slogan pb-0' : 'text-h2 pb-0 display-slogan-chi' ">{{$t('sponsors.falm')}}</h2>
            <h1 :class="lang=='en'?'text-h1 display-header pb-4':'text-h1 display-header-chi pb-4'" >{{$t('sponsors.hklii23')}}</h1>

            <v-row no-gutters>
              <v-col cols="12" md="9" lg="8" class="intro-text">
              <v-divider class="white mb-3" width="30%" ></v-divider>
              <div class="intro-text" v-html="$t('sponsors.intro')"></div>
              </v-col>
            </v-row>

            <v-btn 
              large elevation="10" color="primary"
              class="white--text cta-donate my-3"
              min-width="230px"
              href="https://eform.giving.hku.hk/zend/online_donation/hong_kong_legal_information_institute" target="_blank">
              <v-icon color="white" class="mr-5">mdi-charity</v-icon>
              {{$t('btntxt.donate')}}
            </v-btn>
          </v-col>
          <!--SPACER RIGHT PANEL--><v-col cols="12" md="12" lg="3" class="hidden-md-and-down"></v-col>
        </v-row><!--close PAGE TITLE-->

        <v-row no-gutters class="pa-0" justify="center">
          <v-img class="pa-0"
            min-width="3000"
            max-width="3000"
            max-height="150"
            height="130"
            position="center bottom"
            :src="require('../assets/sponsors23/header_wave.svg')"
            />
        </v-row>
      </div>
    </template>
    
    <template v-slot:mainPanel>
      <!--<SponsorTier :name="$t('sponsors.tier_diamond')" :amount="$t('sponsors.tier_diamond_amt')" />
      <v-row class="mb-10">
        <SponsorCard :name="'Freshfields'" :logo="'sample_logo.png'" :link="'https://www.twobirds.com'" col="12" mdcol="6" />
        <SponsorCardIndi :name="'Ryan Wing Keung POON'"  col="12" mdcol="6" />
      </v-row>-->
      
      <!--<SponsorTier :name="$t('sponsors.tier_platinum')" :amount="$t('sponsors.tier_platinum_amt')"/>
      <v-row class="mb-10">
        <SponsorCard :name="'Freshfields'" :logo="'sample_logo.png'" :link="'ai.hklii.hk/case-summary'" col="6" mdcol="4" />
        <SponsorCardIndi :name="'Ryan Wing Keung POON With Link'" :link="'https://www.twobirds.com'" col="6" mdcol="4" />
      </v-row>-->

      <SponsorTier :name="$t('sponsors.tier_gold')" :amount="$t('sponsors.tier_gold_amt')"/>
      <v-row class="mb-10">
        <SponsorCard :name="'RPC'" :logo="'sponsor_RPC.png'" :link="'https://www.rpc.co.uk/'" col="4" mdcol="3" />
      </v-row>

      <SponsorTier :name="$t('sponsors.tier_other')" :amount="$t('sponsors.tier_other_amt')"/>
      <v-row no-gutters>    
        <v-col cols="12">
          <ul class="other-donor-names" >
            <li v-for="(sponsor, index) in otherSponsors" :key="index">
              <a v-if="sponsor.link" :href="sponsor.link" target="_blank">
              <span>{{sponsor.name}}</span>
              </a>
              <span v-else>{{sponsor.name}}</span>
              
            </li>
          </ul>
        </v-col>
      </v-row>

    </template><!--close MAIN-->

    <template v-slot:bottomPanel>
      <div class="sponsor-footer" >
        <v-row no-gutters class="pa-0 justify-center">
          <v-img class="pa-0"
            min-width="3000"
            max-width="3000"
            max-height="100"
            height="100"
            position="top center"
            :src="require('../assets/sponsors23/footer_wave.svg')"
            />
        </v-row>
        <v-row no-gutters class="d-flex justify-center">
          <!--SPACER LEFT PANEL--><v-col cols="12" md="2" lg="2" :class="$vuetify.breakpoint.mdAndUp?'pt-8':'pt-4'"  class="hidden-sm-and-down"></v-col> 

          <v-col cols="12" md="9" lg="7" class="px-6 pl-lg-12 pl-xl-16 pb-15" >
            <v-row no-gutters class="pt-0">
              <h1 class="text-h1 white--text">{{$t('sponsors.sponsorcall')}}</h1>
            </v-row>
            <v-row>
              <v-col cols="12" md="7" class="intro-text pr-md-8">
                <p>{{$t('sponsors.sponsorintro')}}</p>

                <v-expansion-panels accordion multiple class="cta-tier-desc" >
                  <v-expansion-panel>
                    <v-expansion-panel-header class="liiblack lighten-5 px-3 align-end" >{{$t('sponsors.tier_diamond')}}
                      <span class="pl-4 footer-amt">({{$t('sponsors.tier_diamond_amt')}})</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="footergrey lighten-1">
                      <p class="mb-0 font-weight-bold">{{$t('sponsors.term_recog_long')}}</p>
                      <ul>
                        <li><p class="mb-0">{{$t('sponsors.term_name')}}</p></li>
                        <li><p>{{$t('sponsors.term_logo', [$t('sponsors.term_logo_l')])}}</p></li>
                      </ul>
                      <p class="font-weight-bold">{{$t('sponsors.term_promo')}}</p>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header  class="liiblack lighten-5 px-3 align-end">{{$t('sponsors.tier_platinum')}}
                      <span class="pl-4 footer-amt">({{$t('sponsors.tier_platinum_amt')}})</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="footergrey lighten-1">
                      <p class="mb-0 font-weight-bold">{{$t('sponsors.term_recog_long')}}</p>
                      <ul>
                        <li><p class="mb-0">{{$t('sponsors.term_name')}}</p></li>
                        <li><p>{{$t('sponsors.term_logo', [$t('sponsors.term_logo_m')])}}</p></li>
                      </ul>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header  class="liiblack lighten-5 px-3 align-end">{{$t('sponsors.tier_gold')}}
                      <span class="pl-4 footer-amt">({{$t('sponsors.tier_gold_amt')}})</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="footergrey lighten-1">
                      <p class="mb-0 font-weight-bold">{{$t('sponsors.term_recog_long')}}</p>
                      <ul>
                        <li><p class="mb-0">{{$t('sponsors.term_name')}}</p></li>
                        <li><p>{{$t('sponsors.term_logo', [$t('sponsors.term_logo_s')])}}</p></li>
                      </ul>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                    <v-expansion-panel>
                    <v-expansion-panel-header  class="liiblack lighten-5 px-3 align-end">{{$t('sponsors.tier_other')}}
                      <span class="pl-4 footer-amt">({{$t('sponsors.tier_other_amt')}})</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="footergrey lighten-1">
                      <p class="mb-0 font-weight-bold">{{$t('sponsors.term_recog_short')}}</p>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <p class="pt-4">{{$t('sponsors.tax_deduction')}}</p>

                <p v-html="$t('sponsors.enquire')"> </p>

              </v-col>

              <v-col cols="12" md="5" class="intro-text">
                <v-divider class="white" :width="$vuetify.breakpoint.sm?'50%':'100%'"></v-divider>
                <h5 class="text-h5 white--text mt-1 mb-2">{{$t('sponsors.donateonline')}}</h5>
                <v-btn 
                  large elevation="10" color="primary"
                  class="white--text cta-donate mb-5"
                  min-width="230px"
                  href="https://eform.giving.hku.hk/zend/online_donation/hong_kong_legal_information_institute" target="_blank">
                  <v-icon color="white" class="mr-5">mdi-charity</v-icon>
                  {{$t('btntxt.donate')}}
                </v-btn>

                <v-divider class="white" :width="$vuetify.breakpoint.sm?'50%':'100%'" ></v-divider>
                <h5 class="text-h5 white--text mt-1 mb-2">{{$t('sponsors.cheque_title')}}</h5>
                <p> {{$t('sponsors.cheque_text')}}</p>
                <p v-html="$t('sponsors.cheque_addr')">
                </p>
              
              </v-col>
            </v-row>

          </v-col>
          
          <!--SPACER RIGHT PANEL--><v-col cols="12" md="12" lg="3" class="px-7 pt-6  hidden-md-and-down"></v-col>
        </v-row>
      </div>
    </template>

  </ThreeColumn>
</template>

<script>
import ThreeColumn from '@/components/applayout/ThreeColumn'
import SponsorTier from '@/components/sponsors/SponsorTier.vue'
import SponsorCard from '@/components/sponsors/SponsorCard.vue'
import SponsorCardIndi from '@/components/sponsors/SponsorCardIndi.vue'
export default {
  name:"HKLII2023",
  data(){
    return {
      otherSponsors: [ 
        {'name': 'Miss Helen Au Yuen Yee'},
        {'name': 'Miss Dora Chan Shuk Yee'},
        {'name': 'Mr Jonathan Cheng'},
        {'name': 'Mr Sidney Fong Hok Nang'},
        {'name': 'Mr Fong Shiu Lap Oscar'},
        {'name': 'Freshfields'},
        {'name': 'Ms Mindy Ho Sze May'},
        {'name': 'George K. Konstantinou LLC', 'link':'https://gk-lawfirm.com/'},
        {'name': 'Ms Leung Yi Ching'},
        {'name': 'Mr Tony Liu'},
        {'name': 'Mrs Angel Mak Daley'},
        {'name': 'Mr Ryan Poon Wing Keung'},
        {'name': 'Miss Julie Qi Yue'},
        {'name': 'Mr Shum Ching San J'},
      ],
    }
  },
  computed:{
    paths(){
      return [
        {text: 'HKLII', disabled: false, href: {name: 'home'}},
        {text: 'HKLII 2023', disabled: true}
      ]
    },
    lang(){
      return this.$i18n.locale||''
    }
  },
  components:{
        ThreeColumn,
        SponsorTier,
        SponsorCard,
        SponsorCardIndi,
  },
  /*mounted(){
    window.document.title = "HKLII 2023 | HKLII"
  },*/
  metaInfo:{
    title: "HKLII 2023",
  },
}
</script>

<style scoped lang="scss">
  @import '@/sass/_typography.scss';

  /*bg*/
  .sponsor-header{
    background-image: url(../assets/sponsors23/sponsor_header.png);
    background-position: bottom center;
  }
  .sponsor-footer{
    background-image: url(../assets/sponsors23/sponsor_footer.png);
    background-position: 50% top;
    background-color: #74333b;
  }

  /*typography*/
  a{
    @include link-no-underline;
  }

  .cta-donate:hover{ /*remove underline for button*/
    text-decoration: none !important;
  }

  .display-slogan{
    font-family: 'Noto Serif Display' !important;
    font-size: 1.8em !important;
    font-style: italic ;
    color: white;
    line-height: 1.1em;
  }
  .display-slogan-chi{
    font-size: 1.8em !important;
    font-style: italic ;
    color: white;
    line-height: 1.1em;
  }
  .display-header{
    font-size: 4.2em !important;
    line-height: 1em;
    letter-spacing: 2px !important;
    color: white;
  }
  .display-header-chi{
    font-size: 3.7em !important;
    line-height: 1.1em;
    letter-spacing: 2px !important;
    color: white;
  }
  .intro-text ::v-deep p{
    color: white;
    margin-bottom: 10px;
    font-size: 0.9em ;
  }

  .intro-text ::v-deep a{
    color: var(--v-link-lighten3);
    text-decoration: none;
  }
  .intro-text ::v-deep a:hover{
    text-decoration: underline var(--v-link-lighten3) solid 1px;
    text-underline-offset: 2px;
  }

  /*other donor names*/
  .other-donor-names{
    list-style-type: none;
    padding-left: 0px; 
    @media only screen and (min-width: 480px) {
      -webkit-column-count: 2;
      -moz-column-count: 2;
      column-count: 2;
      column-gap: 20px;
    }
    @media only screen and (min-width: 768px){
      -webkit-column-count: 3;
      -moz-column-count: 3;
      column-count: 3;
      column-gap: 20px;
    }
    a{
      @include link-no-underline(rgba(0, 0, 0, 0.95));
    }
    li{
      padding-bottom: 10px;
    }
  }
  
  /*footer*/
  .cta p{
    color: white;
  }
  .cta a{
    @include link-no-underline(var(--v-link-lighten3));
  }
  .cta-tier-desc p{
    color: rgba(0, 0, 0, 0.8);
  }
  
  /*accordian footer*/
  .v-expansion-panels{
    max-width: 500px;
  }
  ::v-deep .v-expansion-panel-content__wrap{
    padding: 6px 12px;
  }
  ::v-deep .v-expansion-panel--active > .v-expansion-panel-header{
    min-height: 30px;
  }
  .footer-amt{
    color: var(--v-liiblack-lighten-1);
    font-size: 0.77rem;
  }

</style>
